import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "section-studio",
  class: "section-studio"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "nft-box font-blackopsone" }
const _hoisted_4 = { class: "commnet-box" }
const _hoisted_5 = {
  key: 0,
  class: "box"
}
const _hoisted_6 = { class: "input-token-box" }
const _hoisted_7 = { class: "pluto-input-number" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "prefix" }, " # ", -1)
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h5", null, "Enter your Studio #ID", -1)
const _hoisted_11 = { class: "item-speaker item-speaker-l" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "item-speaker item-speaker-r" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "desk-box" }
const _hoisted_16 = {
  id: "desk-base",
  class: "desk-base"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  id: "desk",
  class: "desk"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "desk-bottom" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "box" }
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "progress" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "link" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#tutorial" }, "How to play")
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "slogan-bar font-blackopsone" }, " Pluto Studio / Pluto Studio / Pluto Studio / Pluto Studio / Pluto Studio / Pluto Studio / Pluto Studio / Pluto Studio /  ", -1)
const _hoisted_33 = {
  id: "tutorial",
  class: "section-tutorial"
}
const _hoisted_34 = { class: "title" }
const _hoisted_35 = { class: "content font-blackopsone desktop" }
const _hoisted_36 = { class: "tutor-box tutor-box-left" }
const _hoisted_37 = { class: "tutor-item" }
const _hoisted_38 = { class: "btn-box" }
const _hoisted_39 = { class: "pad-btn" }
const _hoisted_40 = {
  key: 0,
  class: "break"
}
const _hoisted_41 = { class: "tutor-item" }
const _hoisted_42 = { class: "btn-box" }
const _hoisted_43 = { class: "pad-btn" }
const _hoisted_44 = {
  key: 0,
  class: "break"
}
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<div class=\"tutor-item\"><div class=\"btn-box\"><button class=\"pad-btn\"> Q </button><button class=\"pad-btn\"> W </button><span>...</span><button class=\"pad-btn\"> I </button><button class=\"pad-btn\"> O </button></div></div><div class=\"tutor-item\"><div class=\"btn-box\"><button class=\"pad-btn\"> A </button><button class=\"pad-btn\"> S </button><span>...</span><button class=\"pad-btn\"> J </button><button class=\"pad-btn\"> K </button></div></div><div class=\"tutor-item\"><div class=\"btn-box\"><button class=\"pad-btn pad-btn-space\"> SPACE </button></div></div>", 3)
const _hoisted_48 = { class: "tutor-box tutor-box-right" }
const _hoisted_49 = { class: "tutor-item" }
const _hoisted_50 = { class: "tutor-item" }
const _hoisted_51 = { class: "tutor-item" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_54 = { class: "tutor-item" }
const _hoisted_55 = { class: "tutor-item" }
const _hoisted_56 = { class: "content font-blackopsone mobile" }
const _hoisted_57 = { class: "tutor-item" }
const _hoisted_58 = { class: "tutor-item-left" }
const _hoisted_59 = { class: "pad-btn" }
const _hoisted_60 = {
  key: 0,
  class: "break"
}
const _hoisted_61 = { class: "tutor-item-right" }
const _hoisted_62 = { class: "tutor-item" }
const _hoisted_63 = { class: "tutor-item-left" }
const _hoisted_64 = { class: "pad-btn" }
const _hoisted_65 = {
  key: 0,
  class: "break"
}
const _hoisted_66 = { class: "tutor-item-right" }
const _hoisted_67 = { class: "tutor-item" }
const _hoisted_68 = /*#__PURE__*/_createStaticVNode("<div class=\"tutor-item-left\"><div class=\"wrapper\"><button class=\"pad-btn\"> Q </button><button class=\"pad-btn\"> W </button><br><span>...</span><br><button class=\"pad-btn\"> I </button><button class=\"pad-btn\"> O </button></div></div>", 1)
const _hoisted_69 = { class: "tutor-item-right" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_72 = { class: "tutor-item" }
const _hoisted_73 = /*#__PURE__*/_createStaticVNode("<div class=\"tutor-item-left\"><div class=\"wrapper\"><button class=\"pad-btn\"> A </button><button class=\"pad-btn\"> S </button><br><span>...</span><br><button class=\"pad-btn\"> K </button><button class=\"pad-btn\"> L </button></div></div>", 1)
const _hoisted_74 = { class: "tutor-item-right" }
const _hoisted_75 = { class: "tutor-item" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "tutor-item-left" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "pad-btn pad-btn-space" }, " SPACE ")
], -1)
const _hoisted_77 = { class: "tutor-item-right" }
const _hoisted_78 = { class: "section-video" }
const _hoisted_79 = { class: "title" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "content font-blackopsone" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "youtube-box" }, [
    /*#__PURE__*/_createElementVNode("iframe", {
      class: "youtube-player",
      src: "https://www.youtube.com/embed/AB_1WUcpRa8",
      title: "Pluto Studio Tutorial",
      frameborder: "0",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowfullscreen: ""
    })
  ])
], -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("p", { class: "slogan-bar font-blackopsone" }, " Pluto Studio / Pluto Studio / Pluto Studio / Pluto Studio / Pluto Studio / Pluto Studio / Pluto Studio / Pluto Studio /  ", -1)

import axios from 'axios';
import { onMounted, ref, computed, reactive } from 'vue';
import Vue3Marquee from 'vue3-marquee';
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue';
import Icons from '@/components/Icon/Icons.vue';
import NftItem from '@/components/NftItem.vue';
import PlutoEffect from '@/components/PlutoEffect.vue';
import Web3Board from '@/ethers/components/Board.vue';
import { GlobalStore } from '@/store/GlobalStore';
import { Web3Store } from '@/store/Web3Store';
import { goPage, RoutePath } from '@/utils/url';
import { SynthInfo, synthMap, useHiphop } from '@/utils/useHiphop';
import { getProSynths, MetadataAttributeType, metadataToProSynths, TraitKey } from '@/utils/usePluto';

// import { useTwo } from '@/utils/useTwo';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const plutoEffectRef = ref<InstanceType<typeof Element>>();
const divRef = ref<InstanceType<typeof Element>>();

// defineExpose({ plutoEffectRef, });

const {
  connectWallet,
  active,
  account,
  plutoHiphopStuidoContract,
} = Web3Store;

const MAX_WIDTH = 1280;
const { isMobile, } = GlobalStore;

const onPlayHookList: Function[] = [];
const onPlayHook = (func: (key: string) => void) => {
  onPlayHookList.push(func);
  return () => {
    onPlayHookList.splice(onPlayHookList.indexOf(func), 1);
  };
};
const { init, keyMap, currentNote, play, stopAll, isLoaded, isPlaying, } = useHiphop(onPlay);
function onPlay(key: string, index: number, keyMap: synthMap<SynthInfo>) {
  if (key === 'B') {
    const pk = keyMap[key][index].pk;
    if (pk) {
      // console.log(plutoEffectRef.value, (keyMap[key][index].pk));
      onPlayHookList.forEach(func => func(keyMap[key][index].pk));
      // animateHandler(pk);
    }
  }
}
const _baseWidth = ref(720);
const deskWidth = ref(200);
const bottomeMargin = `${1120 * 0.024}px`;

const elePadBoxLeft = computed(() => {
  return `${getNumber(deskWidth.value * 0.208)}px`;
});
const queryParams = new Proxy(new URLSearchParams(window.location.search) as any, {
  get: (searchParams, prop) => searchParams.get(prop as string),
});
const tokenId = ref<number>();
const isTrial = computed(() => tokenId.value === 0);
const plutoState = reactive({
  cover: require('@/assets/images/hiphop/nft-cover/purple.png'),
  // tokenId: tokenId.value,
  image: '', // require('@/assets/images/9943-2.png'),
});
const getNftCoverUrl = (attrs: MetadataAttributeType) => {
  // eslint-disable-next-line camelcase
  const bodyTrait = attrs.find(({ trait_type, }) => trait_type === TraitKey.Body)?.value || '';
  return require(`@/assets/images/hiphop/nft-cover/${bodyTrait.toLowerCase()}.png`);
};
// Get the value of "some_key" in eg "https://example.com/?some_key=some_value"

onMounted(() => {
  window.requestAnimationFrame(step);
  // const metadata = require('@/pub');

  resizeSection();

  setTimeout(() => {
    resizeSection();
  }, 1000);

  window.addEventListener('resize', () => {
    resizeSection();
    // console.log(_baseWidth);
  });

  // const eleStudio = document.getElementById('section-studio');
  // if (eleStudio) {
  //   const { two, } = useTwo(eleStudio);
  //   console.log('two', two);
  // }
});

function resizeSection() {
  const Section = document.querySelector('.section-studio') as any;
  if (Section) {
    const height = Math.min(window.innerHeight, 820);
    // window.innerHeight - header.getBoundingClientRect().height;
    Section.style.height = `${height}px`;
  }

  _baseWidth.value = window.innerWidth;
  deskWidth.value = document.getElementById('desk-base')?.getClientRects()[0].width || 460;

  const youtube = document.getElementById('pluto-video');
  if (youtube) {
    // 560 * 315
    const width = youtube.getBoundingClientRect().width;
    youtube.style.height = `${width / 560 * 315}px`;
  }
}

function getNumber(num: number) {
  return Math.min(MAX_WIDTH, Math.round(num));
}

const loadingPercent = ref(0);
const loadingPercentStart = ref(0);
const isHideLoading = ref(true);

function step(timestamp: number) {
  if (!loadingPercentStart.value) loadingPercentStart.value = timestamp;
  var progress = timestamp - loadingPercentStart.value;
  const n = Math.round(progress * 0.7) / 10000;
  loadingPercent.value = Math.round(easeOutCirc(n) * 100);
  if (isLoaded.value) {
    loadingPercent.value = 100;
    setTimeout(() => {
      isHideLoading.value = true;
    }, 1000);
    return;
  } else {
    loadingPercent.value = Math.min(loadingPercent.value, progress > 15000 ? 99 : 98);
  }
  if (loadingPercent.value < 100) {
    window.requestAnimationFrame(step);
  }
}

function easeOutCirc(x: number): number {
  return 1 - Math.pow(1 - x, 3);
}

//
const cancel = () => {
  window.location.reload();
};
const studioState = reactive({
  isConfirmed: false,
});
const enterNft = async() => {
  if (!tokenId.value) {
    return;
  }
  isHideLoading.value = false;
  try {
    const owner = await plutoHiphopStuidoContract.value?.ownerOf(tokenId.value);
    if (owner !== account.value) {
      throw new Error('You are not the owner of this NFT');
    }
  } catch (error: any) {
    const msg = error.error?.message || error.message || error.message || 'Something went wrong';
    alert(msg);
    // alert(error?.message);
    isHideLoading.value = true;
    return;
  }

  try {
    // const uri = await plutoHiphopContract.value?.tokenURI(tokenId.value);
    const uri = await plutoHiphopStuidoContract.value?.tokenURI(tokenId.value);
    if (!uri) {
      throw new Error('Invalid tokenId');
    }
    studioState.isConfirmed = true;
    const json = await axios.get(uri);
    if (json) {
      const proSynth = metadataToProSynths(json.data);
      getProSynths(proSynth).then(({ specialSynthUrls, }) => {
        // plutoState.cover = getNftCoverUrl(json.data.attributes);
        plutoState.cover = json.data.image;

        // console.log('json', json);
        init(specialSynthUrls, isTrial.value, tokenId.value);
      });
    } else {
      throw new Error('erro');
    }
  } catch (error: any) {
    alert(error.message);
    studioState.isConfirmed = false;
    isHideLoading.value = true;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      translate: "no",
      class: _normalizeClass(["app page-studio", [_unref(isMobile) ? 'mobile' : 'desktop']])
    }, [
      _createVNode(Header),
      _createElementVNode("section", _hoisted_1, [
        _createVNode(PlutoEffect, {
          ref_key: "plutoEffectRef",
          ref: plutoEffectRef,
          onParentFunc: onPlayHook
        }, null, 512),
        _createElementVNode("div", {
          ref_key: "divRef",
          ref: divRef
        }, null, 512),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "demo-box",
            style: _normalizeStyle({'margin-bottom': bottomeMargin})
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(NftItem, {
                plutoState: _unref(plutoState),
                isPlaying: _unref(isPlaying)
              }, null, 8, ["plutoState", "isPlaying"]),
              _createElementVNode("div", _hoisted_4, [
                (!_unref(active))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(connectWallet) && _unref(connectWallet)(...args))),
                        class: "pluto-button pluto-button-primary"
                      }, " CONNECT ")
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _hoisted_8,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tokenId).value = $event)),
                            type: "number",
                            max: "9999",
                            min: "1",
                            maxlength: "4",
                            placeholder: "ID",
                            disabled: _unref(studioState).isConfirmed
                          }, null, 8, _hoisted_9), [
                            [_vModelText, tokenId.value]
                          ])
                        ]),
                        (!_unref(studioState).isConfirmed)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: enterNft,
                              class: _normalizeClass(["pluto-button pluto-button-primary", {'disabled': !tokenId.value || tokenId.value === 0}])
                            }, " ENTER ", 2))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              onClick: cancel,
                              class: _normalizeClass(["pluto-button", {'disabled': !tokenId.value || tokenId.value === 0}])
                            }, " CANCEL ", 2))
                      ]),
                      _hoisted_10
                    ], 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("img", {
                src: require('@/assets/images/hiphop/speaker-l.png')
              }, null, 8, _hoisted_12)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("img", {
                src: require('@/assets/images/hiphop/speaker-r.png')
              }, null, 8, _hoisted_14)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", {
                  class: "pad-box",
                  style: _normalizeStyle({'margin-left': _unref(elePadBoxLeft)})
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(keyMap).A, (item, idx) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: item.k,
                      class: _normalizeClass([{'disabled': !item.e, 'special': item.s, 'active': _unref(currentNote).A === item.k}, "pad-btn"]),
                      onClick: ($event: any) => (!item.e ? () => {} : _unref(play)('A', idx, item.k))
                    }, _toDisplayString(item.n), 11, _hoisted_17))
                  }), 128)),
                  _hoisted_18,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(keyMap).B, (item, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.k,
                      class: _normalizeClass([{'disabled': !item.e, 'special': item.s, 'active': _unref(currentNote).B.includes(item.k)}, "pad-btn"]),
                      onClick: ($event: any) => (!item.e ? () => {} : _unref(play)('B', idx, item.k))
                    }, _toDisplayString(item.n), 11, _hoisted_19))
                  }), 128)),
                  _hoisted_20,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(keyMap).C, (item, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.k,
                      class: _normalizeClass([{'disabled': !item.e, 'special': item.s, 'active': _unref(currentNote).C.includes(item.k)}, "pad-btn"]),
                      onClick: ($event: any) => (!item.e ? () => {} : _unref(play)('C', idx, item.k))
                    }, _toDisplayString(item.n), 11, _hoisted_21))
                  }), 128)),
                  _hoisted_22,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(keyMap).D, (item, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.k,
                      class: _normalizeClass([{'disabled': !item.e, 'special': item.s, 'active': _unref(currentNote).D === item.k}, "pad-btn"]),
                      onClick: ($event: any) => (!item.e ? () => {} : _unref(play)('D', idx, item.k))
                    }, _toDisplayString(item.n), 11, _hoisted_23))
                  }), 128)),
                  _createElementVNode("div", {
                    class: "pad-btn pad-btn-space",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(stopAll)()))
                  }, " RESET ")
                ], 4),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("img", {
                    src: require('@/assets/images/hiphop/desk.png')
                  }, null, 8, _hoisted_25)
                ])
              ])
            ])
          ], 4),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("img", {
              src: require('@/assets/images/hiphop/desk-bottom.png')
            }, null, 8, _hoisted_27)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["loading-mask", {'loaded': isHideLoading.value}])
        }, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("img", {
              class: "logo-img",
              src: require('@/assets/images/v33_11.png'),
              alt: "logo"
            }, null, 8, _hoisted_29),
            _createElementVNode("p", _hoisted_30, _toDisplayString(loadingPercent.value) + " % ", 1),
            _hoisted_31
          ])
        ], 2)
      ]),
      _createVNode(_unref(Vue3Marquee), { clone: true }, {
        default: _withCtx(() => [
          _hoisted_32
        ]),
        _: 1
      }),
      _createElementVNode("section", _hoisted_33, [
        _createElementVNode("h2", _hoisted_34, _toDisplayString(_ctx.$t('STUDIO_1')), 1),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['1', '2', '3', '4','5','6','7','8'], (item, idx) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                    _createElementVNode("button", _hoisted_39, _toDisplayString(item), 1),
                    (idx===3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Z','X','C','V','B','N','M'], (item, idx) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                    _createElementVNode("button", _hoisted_43, _toDisplayString(item), 1),
                    (idx===3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 64))
              ])
            ]),
            _hoisted_45
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("p", null, "1. " + _toDisplayString(_ctx.$t('STUDIO_2')), 1)
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("p", null, "2. " + _toDisplayString(_ctx.$t('STUDIO_3')), 1)
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("p", null, [
                _createTextVNode("3. " + _toDisplayString(_ctx.$t('STUDIO_10')) + " ", 1),
                _hoisted_52,
                _createTextVNode(" (" + _toDisplayString(_ctx.$t('STUDIO_11')), 1),
                _hoisted_53,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('STUDIO_12')) + " )", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("p", null, "4. " + _toDisplayString(_ctx.$t('STUDIO_13')), 1)
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("p", null, "5. " + _toDisplayString(_ctx.$t('STUDIO_6')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(keyMap).A, (item, idx) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.k
                }, [
                  _createElementVNode("button", _hoisted_59, _toDisplayString(item.n), 1),
                  ((idx+1)%3===0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("p", null, "1. " + _toDisplayString(_ctx.$t('STUDIO_2')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(keyMap).D, (item, idx) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.k
                }, [
                  _createElementVNode("button", _hoisted_64, _toDisplayString(item.n), 1),
                  ((idx+1)%3===0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_65))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("p", null, "2. " + _toDisplayString(_ctx.$t('STUDIO_3')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _hoisted_68,
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("p", null, [
                _createTextVNode(" 3. " + _toDisplayString(_ctx.$t('STUDIO_10')) + " ", 1),
                _hoisted_70,
                _createTextVNode(" (" + _toDisplayString(_ctx.$t('STUDIO_11')) + " ", 1),
                _hoisted_71,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('STUDIO_12')) + " ) ", 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_72, [
            _hoisted_73,
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("p", null, " 4. " + _toDisplayString(_ctx.$t('STUDIO_13')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_75, [
            _hoisted_76,
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("p", null, "5. " + _toDisplayString(_ctx.$t('STUDIO_6')), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_78, [
        _createElementVNode("h2", _hoisted_79, _toDisplayString(_ctx.$t('STUDIO_8')), 1),
        _hoisted_80
      ]),
      _createVNode(_unref(Vue3Marquee), {
        direction: 'reverse',
        clone: true
      }, {
        default: _withCtx(() => [
          _hoisted_81
        ]),
        _: 1
      }),
      _createVNode(Footer),
      _createVNode(Icons)
    ], 2),
    _createVNode(Web3Board)
  ], 64))
}
}

})